<div class="card card-nb" [ngClass]="{'h-100' : stretch}">
    <div class="card-body d-flex flex-column h-100">
      <ng-content></ng-content>
    </div>
</div>

